import React from "react";

import { ReactComponent as LockIcon } from "../../../assets/images/grace-period/LockBGTransparent.svg";

import "./LockedContent.css";

const FAKE_BAR_HEIGHTS = [38, 62, 46, 78, 54, 70, 42, 58];
const FAKE_SUMMARY_SEGMENTS = [
  { width: 36, color: "var(--color-content-negative)", labelWidth: 88 },
  { width: 52, color: "var(--color-content-positive)", labelWidth: 56 },
  { width: 12, color: "var(--color-content-warning)", labelWidth: 112 },
];

function FakeChart({ variant }) {
  if (variant === "summary") {
    return (
      <div className="LockedContent__Placeholder LockedContent__Placeholder--summary" aria-hidden>
        <div className="LockedContent__FakeStackedBar">
          {FAKE_SUMMARY_SEGMENTS.map((segment) => (
            <span
              key={segment.color}
              className="LockedContent__FakeStackedSegment"
              style={{
                width: `${segment.width}%`,
                backgroundColor: segment.color,
              }}
            />
          ))}
        </div>
        <div className="LockedContent__FakeSummaryList">
          {FAKE_SUMMARY_SEGMENTS.map((segment) => (
            <div key={`${segment.color}-row`} className="LockedContent__FakeSummaryRow">
              <div className="LockedContent__FakeSummaryLabel">
                <span
                  className="LockedContent__FakeSummaryDot"
                  style={{ backgroundColor: segment.color }}
                />
                <span
                  className="LockedContent__FakeSummaryLabelBar"
                  style={{ width: segment.labelWidth }}
                />
              </div>
              <span className="LockedContent__FakeSummaryValue" />
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (variant === "line") {
    return (
      <div className="LockedContent__Placeholder LockedContent__Placeholder--line" aria-hidden>
        <svg className="LockedContent__FakeSvg" viewBox="0 0 400 160" preserveAspectRatio="none">
          <path
            className="LockedContent__FakeLine LockedContent__FakeLine--secondary"
            d="M8 138 C 60 128, 100 90, 160 105 S 240 70, 300 95 S 360 110, 392 88"
          />
          <path
            className="LockedContent__FakeLine"
            d="M8 120 C 50 110, 80 40, 130 70 S 210 20, 260 55 S 340 90, 392 45"
          />
        </svg>
      </div>
    );
  }

  if (variant === "area") {
    return (
      <div className="LockedContent__Placeholder LockedContent__Placeholder--area" aria-hidden>
        <svg className="LockedContent__FakeSvg" viewBox="0 0 400 160" preserveAspectRatio="none">
          <path
            className="LockedContent__FakeArea"
            d="M8 152 L8 118 C 50 108, 90 48, 140 72 S 220 28, 270 58 S 340 92, 392 50 L392 152 Z"
          />
          <path
            className="LockedContent__FakeLine"
            d="M8 118 C 50 108, 90 48, 140 72 S 220 28, 270 58 S 340 92, 392 50"
          />
        </svg>
      </div>
    );
  }

  if (variant === "map") {
    return (
      <div className="LockedContent__Placeholder LockedContent__Placeholder--map" aria-hidden>
        <div className="LockedContent__FakeMapGrid">
          <span className="LockedContent__FakeRoom LockedContent__FakeRoom--wide">
            <span className="LockedContent__FakePin" style={{ top: "28%", left: "22%" }} />
            <span className="LockedContent__FakePin LockedContent__FakePin--alt" style={{ top: "62%", left: "68%" }} />
          </span>
          <span className="LockedContent__FakeRoom LockedContent__FakeRoom--tall">
            <span className="LockedContent__FakePin" style={{ top: "18%", left: "48%" }} />
            <span className="LockedContent__FakePin LockedContent__FakePin--alt" style={{ top: "72%", left: "36%" }} />
          </span>
          <span className="LockedContent__FakeCorridor" />
          <span className="LockedContent__FakeRoom">
            <span className="LockedContent__FakePin LockedContent__FakePin--alt" style={{ top: "40%", left: "30%" }} />
          </span>
          <span className="LockedContent__FakeRoom">
            <span className="LockedContent__FakePin" style={{ top: "55%", left: "62%" }} />
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className="LockedContent__Placeholder LockedContent__Placeholder--bar" aria-hidden>
      {FAKE_BAR_HEIGHTS.map((height, index) => (
        <span
          key={`${height}-${index}`}
          className="LockedContent__FakeBar"
          style={{ height: `${height}%` }}
        />
      ))}
    </div>
  );
}

export default function LockedContent({
  image,
  // "bar" | "line" | "area" | "summary" | "map"
  variant = "bar",
  title = "Analytics locked",
  description = "Complete renewal payment to view trends, values and summaries.",
  className = "",
}) {
  return (
    <div className={`LockedContent LockedContent--${variant} ${className}`.trim()}>
      {image ? (
        <img className="LockedContent__Image" src={image} alt="" />
      ) : (
        <FakeChart variant={variant} />
      )}
      <div className="LockedContent__Overlay">
        <LockIcon className="LockedContent__LockIcon" aria-hidden />
        <p className="LockedContent__Title">{title}</p>
        {description && <p className="LockedContent__Description">{description}</p>}
      </div>
    </div>
  );
}
